module.exports = __webpack_public_path__ + "media/welcome.8d30c69a.mp3";